import { formatNumber } from '@trmediaab/zebra-utils';
import PropTypes from 'prop-types';

import Button from 'shared/components/button/Button';
import { getText, hasText } from 'shared/utils/Text';

import styles from './index.module.scss';

const OwnReductionToolbar = ({ isLocked, raceInformation, onReset, rows }) => {
  const betTypeTextID = `bet-type-short_${raceInformation
    .getBetType()
    ?.toLowerCase()}`;
  const betTypeString = hasText(betTypeTextID)
    ? getText(betTypeTextID)
    : raceInformation.getBetType();

  return (
    <div className={styles.wrapper}>
      <div className={styles.texts}>
        {rows
          .map(row => row.data)
          .map((rowData, idx, arr) => {
            const { legNr, ownReductions: percentages } = rowData;

            if (!Array.isArray(percentages)) {
              return null;
            }

            const sum = percentages.reduce((acc, value) => acc + value, 0);

            return (
              <span key={legNr}>
                {betTypeString}-{legNr}:{' '}
                <span className={styles.value}>{formatNumber(sum)}%</span>
                {idx < arr.length - 1 && ', '}
                <wbr />
              </span>
            );
          })}
      </div>

      <Button disabled={isLocked} className={styles.btn} onClick={onReset}>
        {getText('toolbar-ownprofit-button-reset')}
      </Button>
    </div>
  );
};

OwnReductionToolbar.propTypes = {
  isLocked: PropTypes.bool.isRequired,
  onReset: PropTypes.func.isRequired,
  raceInformation: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
};

export default OwnReductionToolbar;
